import StarBulk from "../../assets/bbebf6a8943bdf07.svg";
import Star from "../../assets/724cc9e9243c9102.svg";
import StarFullBulk from "../../assets/3e3c7e5eff85512a.svg";
const BanzaCheckBoxPresets = {
  BanzaCheckbox: {
    attrs: {
      density: "compact"
    },
    presets: {
      star: {
        attrs: {
          TrueState: {
            icon: StarBulk
          },
          FalseState: {
            icon: Star
          },
          IndeterminateState: {
            icon: StarFullBulk
          }
        }
      }
    }
  }
};
export {
  BanzaCheckBoxPresets as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFuemFDaGVja0JveFByZXNldHMuanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb25zdGFudHMvY29tcG9uZW50cy9CYW56YUNoZWNrQm94UHJlc2V0cy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgU3RhckJ1bGsgZnJvbSBcIkAvYXNzZXRzL2ltYWdlcy9TdGFyL1N0YXJCdWxrLnN2Z1wiO1xuaW1wb3J0IFN0YXIgZnJvbSBcIkAvYXNzZXRzL2ltYWdlcy9TdGFyL1N0YXIuc3ZnXCI7XG5pbXBvcnQgU3RhckZ1bGxCdWxrIGZyb20gXCJAL2Fzc2V0cy9pbWFnZXMvU3Rhci9TdGFyRnVsbEJ1bGsuc3ZnXCI7XG5cbmV4cG9ydCBkZWZhdWx0IHtcblx0QmFuemFDaGVja2JveDoge1xuXHRcdGF0dHJzOiB7XG5cdFx0XHRkZW5zaXR5OiBcImNvbXBhY3RcIixcblx0XHR9LFxuXHRcdHByZXNldHM6IHtcblx0XHRcdHN0YXI6IHtcblx0XHRcdFx0YXR0cnM6IHtcblx0XHRcdFx0XHRUcnVlU3RhdGU6IHtcblx0XHRcdFx0XHRcdGljb246IFN0YXJCdWxrLFxuXHRcdFx0XHRcdH0sXG5cdFx0XHRcdFx0RmFsc2VTdGF0ZToge1xuXHRcdFx0XHRcdFx0aWNvbjogU3Rhcixcblx0XHRcdFx0XHR9LFxuXHRcdFx0XHRcdEluZGV0ZXJtaW5hdGVTdGF0ZToge1xuXHRcdFx0XHRcdFx0aWNvbjogU3RhckZ1bGxCdWxrLFxuXHRcdFx0XHRcdH0sXG5cdFx0XHRcdH0sXG5cdFx0XHR9LFxuXHRcdH0sXG5cdH0sXG59O1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUlBLE1BQWUsdUJBQUE7QUFBQSxFQUNkLGVBQWU7QUFBQSxJQUNkLE9BQU87QUFBQSxNQUNOLFNBQVM7QUFBQSxJQUNUO0FBQUEsSUFDRCxTQUFTO0FBQUEsTUFDUixNQUFNO0FBQUEsUUFDTCxPQUFPO0FBQUEsVUFDTixXQUFXO0FBQUEsWUFDVixNQUFNO0FBQUEsVUFDTjtBQUFBLFVBQ0QsWUFBWTtBQUFBLFlBQ1gsTUFBTTtBQUFBLFVBQ047QUFBQSxVQUNELG9CQUFvQjtBQUFBLFlBQ25CLE1BQU07QUFBQSxVQUNOO0FBQUEsUUFDRDtBQUFBLE1BQ0Q7QUFBQSxJQUNEO0FBQUEsRUFDRDtBQUNGOyJ9
